import ActionsContainer from "../../../Pages/EditProduct/Components/ActionsContainer";
import Button from "@material-ui/core/Button";
import ToolbarContainer from "../../../Pages/EditProduct/Components/ToolbarContainer";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "./AppBar";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
    ACTIONS,
    getFirstRenderPartByResource,
    getImageResourceSize,
    getPartRefById, getPartRefs,
    getResource
} from "../../../../Providers/TemplateInstanceProvider";
import {Trans, useTranslation} from "react-i18next";
import ToolbarContent from "../../../Pages/EditProduct/Components/ToolbarContent";
import {Tab, Tabs} from "@material-ui/core";
import ImageInbox from "./ImageInbox";
import Icon from "@material-ui/core/Icon";
import {calculateCropRect, getBoxSize} from "../../../../../utils";
import TemplateContainer from "./TemplateContainer";
import ExitDialog from "../../../Pages/EditProduct/Components/ExitDialog";
import ToolbarToast from "../../../Pages/EditProduct/Components/ToolbarToast";
import EpmsImage from "../../../../Common/EpmsImage";
import TemplatePageList from "./TemplatePageList";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    toolbar: {
        backgroundColor: 'white',
        flexGrow: 0,
        flexShrink: 0
    },
    button: {
        backgroundColor: 'black',
        color: 'white',
        width: '64px',
        height: '64px',
        justifyContent: 'center',
        display: 'center',
        borderRadius: '32px',
        '&:hover': {
            color: 'white',
            backgroundColor: 'black'
        },
        '&.Mui-disabled': {
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    },

    buttonWithText: {
        fontSize: '16px'
    },

    toolBarContainer: {
        width: '100%',
        overflowX: 'auto',
    },
    addImagesButton: {
        height: '64px',
        width: '64px',
        backgroundColor: '#ccc !important',
    },
    toolbarItems: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexWrap: 'nowrap',
        '& > li > button': {
            width: '64px',
            height: '64px',
            marginLeft: theme.spacing(1),
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            borderRadius: '2px',
            overflow: 'hidden',

            '& > img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        },
    },
    rightMenuSpacer: {
        width: theme.spacing(1)
    },
    editImageToolsContainer: {
        padding: theme.spacing(2),
    },
    editImageToolList: {
        display: 'flex',
        justifyContent: 'space-around',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        '& > li': {
            display: 'inline-block'
        },
        '& button': {
            fontSize: '12px',
            display: 'flex',
            flexDirection: 'column',
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main,
            width: '76px',
            height: '74px',
            border: 'none',
            borderBottom: '2px solid ' + theme.palette.primary.main,
            '&.selected': {
                borderBottom: '2px solid ' + theme.palette.secondary.main,
            },
            '& > div': {
                width: '100%',
                flexGrow: 1,
                verticalAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            '& > div:last-child': {
                alignItems: 'flex-start'
            }
        }
    },
    tab: {
        color: theme.palette.primary.main
    },
    dummyImage: {
        display: 'none'
    }
}))

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            style={{flexGrow: 1}}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (<>
                    {children}
                </>
            )}
        </div>
    );
}


const ImagePage = ({changeMenu}) => {
    const classes = useStyles();
    const [state, dispatch] = useTemplateInstance();
    const [currentTab, setCurrentTab] = useState(0)
    const {t} = useTranslation();
    const [localResource, setLocalResource] = useState(null);
    const [dirty, setDirty] = useState(false);
    const [showSaveChangesDialog, setShowSaveChangesDialog] = useState(false);
    const [showPinchToast, setShowPinchToast] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            const partRef = getPartRefById(state.currentPartRefId, state.template)
            console.log('The part ref', partRef, state.template, state.currentResourceId);
            const resource = getResource(partRef, state.currentResourceId, state);
            setLocalResource(resource);
        }, 0)
    }, []);

    useEffect( () => {
        if (!localResource?.image?.uuid) {
            return;
        }
        if (!sessionStorage.getItem('pinch-zoom-info-shown')) {
            setShowPinchToast(true)
            sessionStorage.setItem('pinch-zoom-info-shown', 1);
            const timer = setTimeout(() => {
                setShowPinchToast(false)
            }, 10000)
            return () => {
                clearTimeout(timer);
            }
        }
    }, [localResource && localResource.image.uuid]);


    const handleClosePinchToast = () => {
        setShowPinchToast(false);
    }

    const handleImageLoad = useCallback( () => {
        console.log('Dummy Image loaded!!!')
        setLocalResource(resource => {
            return {
                ...resource,
                image: {
                    ...resource.image,
                    loading: false
                }
            }
        });
    }, []);

    const handleSave = () => {
        if (!localResource.image.uuid) {
            changeMenu('main')
            return;
        }

        const { picturePosition, ...rest} = localResource.image;
        const image = localResource.image;
        if (image.picturePosition) {
            const renderPart = getFirstRenderPartByResource(localResource, state.template);
            const renderPartSize = {
                width: renderPart.size.width * state.scaleRatio,
                height: renderPart.size.height * state.scaleRatio
            }

            console.log('Render part size', renderPartSize);

            const imageSize = getImageResourceSize(image, renderPart);
            const cropRect = calculateCropRect(localResource.image.picturePosition, imageSize, renderPartSize);
            rest.cropRect = {
                x: cropRect.left,
                y: cropRect.top,
                width: cropRect.width,
                height: cropRect.height
            };
        }

        console.log('The rest', rest);

        dispatch({
            type: ACTIONS.UPDATE_CURRENT_IMAGE,
            image: rest
        })

        setLocalResource(null)
        setTimeout(() => {
            changeMenu('main')
        }, 300)
    }

    const handleUpdateRotation = (rotation) => {
        setDirty(true);

        // Don't include picturePosition, as it's reset by crop:
        setLocalResource(resource => {
            const image = {
                uuid: localResource.image.uuid,
                width: localResource.image.width,
                height: localResource.image.height,
                rotation,
            }

            const renderPart = getFirstRenderPartByResource(localResource, state.template);
            const renderPartSize = {
                width: renderPart.size.width * state.scaleRatio,
                height: renderPart.size.height * state.scaleRatio
            }

            const imageSize = getImageResourceSize(image, renderPart);
            const pos = getBoxSize(renderPart.image.adaption, imageSize, renderPartSize);
            const cropRect = calculateCropRect(pos, imageSize, renderPartSize);

            const newResource = {
                ...resource,
                image: {
                    ...image,
                    loading: true,
                    cropRect,
                    overrideEffect: resource.image.overrideEffect || 'original'
                }
            }
            return newResource;
        });
    }

    const updateEffect = (effect) => {
        setDirty(true);
        setLocalResource(resource => {
            console.log('Handle effect update', effect)
            const newResource = {
                ...resource,
                image: {
                    ...resource.image,
                    // Picture position is temp while editing, so we don't have to recalc imagepos => cropRect => imagePos
                    overrideEffect: effect,
                    loading: true,
                }
            }
            return newResource;
        });
    }

    const handleCropComplete = (pos) => {
        setDirty(true);
        setLocalResource(resource => {
            const {picturePosition, ...rest} = resource.image;

            const renderPart = getFirstRenderPartByResource(resource, state.template);
            const renderPartSize = {
                width: renderPart.size.width * state.scaleRatio,
                height: renderPart.size.height * state.scaleRatio
            }

            const imageSize = getImageResourceSize(resource.image, renderPart);
            const cropRect = calculateCropRect(pos, imageSize, renderPartSize);

            const newResource = {
                ...resource,
                image: {
                    ...rest,
                    cropRect: {
                        x: cropRect.left,
                        y: cropRect.top,
                        width: cropRect.width,
                        height: cropRect.height
                    }
                }
            }
            console.log('New resource', resource, rest, newResource);
            return newResource;
        });
    }

    const handleCropUpdate = (pos) => {
        console.log('Crop update');
        setDirty(true);

        // Remove dialog if moving:
        setShowPinchToast(false)

        setLocalResource(resource => {
            console.log('Handle crop update', pos)
           const newResource = {
               ...resource,
               image: {
                   ...resource.image,
                   // Picture position is temp while editing, so we don't have to recalc imagepos => cropRect => imagePos
                   picturePosition: pos
               }
           }
           return newResource;
        });
    }

    const handleSelectImage = (image) => {
        setDirty(true);
        setLocalResource(resource => {
            const renderPart = getFirstRenderPartByResource(localResource, state.template);
            const imageSize = getImageResourceSize(image, renderPart);
            const pos = getBoxSize(renderPart.image.adaption, imageSize, renderPart.size);
            const cropRect = calculateCropRect(pos, imageSize, renderPart.size);
            const cr = {
                x: cropRect.left,
                y: cropRect.top,
                width: cropRect.width,
                height: cropRect.height
            };

            let loading = true;
            // We don't get onLoad event if it's the same image:
            const effect = image.overrideEffect || renderPart.image.effect || 'original';
            const renderEffect = renderPart.image.effect || 'original';
            if (resource.image.uuid == image.uuid && renderEffect == effect) {
                loading = false;
            }

            const newResource = {
                ...resource,
                image: {
                    ...image,
                    cropRect: cr,
                    rotation: 0,
                    loading: loading
                }
            }
            return newResource;
        });
        //handleSelectImage
    }

    const handleCancel = (e) => {
        e.stopPropagation();

        if (dirty) {
            setShowSaveChangesDialog(true);
        }
        else {
            setLocalResource(null);
            setTimeout(() => {
                changeMenu('main')
            }, 300)
        }
    }

    const doClose = () => {
        changeMenu('main')
    }

    return <div className={classes.mainContainer}>
        <AppBar onCancel={handleCancel}/>


        <TemplateContainer zoomResource={localResource}
                           dispatch={dispatch}
                           handleUserImageClick={localResource ? null : () => {
                               // Noop
                           }}
                           handleCropUpdate={handleCropUpdate}
                           handleCropComplete={handleCropComplete} />

        <ToolbarContainer>
            {showPinchToast && <ToolbarToast onClick={handleClosePinchToast}>
                <Trans>Move the picture with your finger. Pinch with two fingers to zoom in/out.</Trans>
            </ToolbarToast>}
            <ToolbarContent>
                <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
                    <Tabs value={currentTab}
                          textColor="secondary"
                          variant='fullWidth'
                          onChange={(e, newVal) => setCurrentTab(newVal)}
                          aria-label="simple tabs example">
                        <Tab label={t('Image inbox')}
                             classes={{textColorSecondary: classes.tab}}
                        />
                        <Tab label={t('Edit image')} disabled={!localResource?.image?.uuid}
                             classes={{textColorSecondary: classes.tab}}
                        />
                    </Tabs>

                    <TabPanel value={currentTab} index={0}>
                        <ImageInbox handleSelectImage={handleSelectImage} resource={localResource}/>
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <EditImageOptions resource={localResource} handleUpdateEffect={updateEffect}
                                          handleUpdateRotation={handleUpdateRotation}/>
                    </TabPanel>
                </div>
            </ToolbarContent>
            <ActionsContainer>
                <Button color="primary" onClick={handleCancel}><Trans>Cancel</Trans></Button>
                <Button color="primary" onClick={handleSave} disabled={!localResource?.image.uuid}><Trans>Done</Trans></Button>
            </ActionsContainer>
        </ToolbarContainer>
        <DummyImage onLoad={handleImageLoad} resource={localResource} state={state}/>
        <ExitDialog open={showSaveChangesDialog}
                    handleCancel={() => setShowSaveChangesDialog(false)}
                    handleOk={doClose} />
    </div>
};

export default ImagePage;

const EditImageOptions = ({resource, handleUpdateEffect, handleUpdateRotation}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    console.log('The resource', resource);

    const handleFilter = (filter) => {
        handleUpdateEffect(filter)
    }

    const handleRotation = () => {
        console.log('Handle rotation', resource);
        let rotation = resource.image.rotation || 0;
        rotation += 90;

        if (rotation == 360) {
            rotation = 0;
        }

        handleUpdateRotation(rotation);
    }

    return <div className={classes.editImageToolsContainer}>
        <ul className={classes.editImageToolList}>
            <li>
                <ImageTool heading={t('Rotate')} icon={<Icon>rotate_90_degrees_cw</Icon>}
                           onClick={handleRotation}/>
            </li>
            <li>
                <ImageTool heading={t('Black/White')} icon={<Icon>filter</Icon>}
                           selected={resource?.image.overrideEffect == 'bw'}
                            onClick={() => handleFilter('bw')} />
            </li>
            <li>
                <ImageTool heading={t('Sepia')} icon={<Icon>filter</Icon>}
                           selected={resource?.image.overrideEffect == 'sepia'}
                           onClick={() => handleFilter('sepia')}/>
            </li>
            <li>
                <ImageTool heading={t('Original')} icon={<Icon>filter</Icon>}
                           selected={!resource?.image.overrideEffect || resource.image.overrideEffect == 'original'}
                           onClick={() => handleFilter('original')} />
            </li>
        </ul>
    </div>
}


// FIXME: This is probably a race condition here? image load effect can come from the wrong image?
const DummyImage = ({onLoad, resource, state}) => {
    const classes = useStyles();
    console.log('Dummy resource', resource)
    const [style, effect, rotation] = useMemo(() => {
        if (!resource?.image.uuid) {
            return [];
        }

        console.log('Stuff. dummy resource')
        const renderPart = getFirstRenderPartByResource(resource, state.template);
        const effect = resource.image.overrideEffect || renderPart.image.effect || 'original'
        const rotation = resource.image.rotation;

        console.log('Dummy resource', renderPart);

        const style = {
            width: renderPart.size.width * state.scaleRatio + 'px',
            height: renderPart.size.height * state.scaleRatio + 'px'
        }
        console.log('Dummy image style', style, state);
        return [style, effect, rotation];
    }, [state.scaleRatio, resource?.image.overrideEffect, resource?.image.rotation])

    if (!resource?.image?.uuid) {
        return null;
    }

    console.log('Dummy image', resource.image.uuid, rotation, effect)

    return <div className={classes.dummyImage} style={style}>
        <EpmsImage onLoad={onLoad} uuid={resource.image.uuid} rotation={rotation} effect={effect} size={640} forceVisible={true}/>
    </div>
}

const ImageTool = ({heading, icon, onClick, selected}) => {
    return <button onClick={onClick} className={selected ? 'selected' : ''}>
        <div>{heading}</div>
        <div>{icon}</div>
    </button>
}
